var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  gridEmpty: '[grid-wishlist-empty]',
  counter: '[counter-wishlist]',
  headerNotice: '[header-notice]'
};

var counters = document.querySelectorAll(selectors.counter);
var headerNotices = document.querySelectorAll(selectors.headerNotice);
var gridEmpty = document.querySelector(selectors.gridEmpty);

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  updateCounter(WISHLIST.length);
});

document.addEventListener('click', function (e) {
  if (e.target.matches(selectors.button) || e.target.closest(selectors.button)) {
    buttonHandler(e);
  }
}, false);

document.addEventListener('wishlist:toggleButtonState', function (e) {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
}, false);

var getSearchQueryString = function (items) {
  return items.map(function (item) {
    return 'id:' + item;
  }).join(' OR ');
};

var setupGrid = function (grid) {
  var queryString = getSearchQueryString(WISHLIST);

  fetch(window.theme.routes.searchUrl + '?view=wishlist&type=product&q=' + queryString).then(function (res) {
    res.text().then(function (wishlistProductCards) {
      grid.innerHTML = wishlistProductCards;
      var buttons = grid.querySelectorAll(selectors.button) || [];
      if (buttons.length) {
        setupButtons(buttons);
      } else {
        gridEmpty.style.display = 'block';
      }
      if (typeof window.initializeQuickAdd === 'function') {
        window.initializeQuickAdd();
      }
    });
  });
};

var buttonHandler = function (e) {
  e.preventDefault();
  var button = e.target.closest(selectors.button);
  var productId = button.dataset.productId || false;
  if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
  updateWishlist(productId);
  var matching_buttons = document.querySelectorAll(selectors.button + '[data-product-id="' + productId + '"]');
  for (var i = 0; i < matching_buttons.length; i++) {
    matching_buttons[i].classList.toggle(BUTTON_ACTIVE_CLASS);
  }
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productId = button.dataset.productId || false;
    if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
    if (wishlistContains(productId)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }
    button.style.visibility = 'visible';
  });
};


var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  WISHLIST = array;
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateCounter = function (count) {
  if (!counters.length) return;

  counters.forEach(function(counter) {
    if (count > 0) {
      counter.innerHTML = count;
      counter.parentNode.classList.add('is-visible');
    } else {
      counter.innerHTML = '';
      counter.parentNode.classList.remove('is-visible');
    }
  });
};

var updateWishlist = function (id) {
  var wishlist = WISHLIST;
  var indexInWishlist = wishlist.indexOf(id);
  if (indexInWishlist === -1) {
    wishlist.push(id);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  updateCounter(wishlist.length);
  if (headerNotices.length) {
    headerNotices.forEach(function(headerNotice) {
      headerNotice.innerHTML = indexInWishlist === -1 ? window.languages.wishlistItemAdded : window.languages.wishlistItemRemoved;
      var popover = headerNotice.closest(selectors.headerWishlistPopover);
      if (popover) {
        popover.classList.add('is-visible');
        setTimeout(function () {
          popover.classList.remove('is-visible');
        }, 2000);
      }
    });
  }

  var grid = document.querySelector(selectors.grid) || false;
  setWishlist(wishlist);
  if (grid) {
    setupGrid(grid);
  }
};

var wishlistContains = function (id) {
  return WISHLIST.indexOf(id) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

var WISHLIST = getWishlist();
